import { jsxs as r, jsx as o } from "react/jsx-runtime";
import { useMultiStyleConfig as m, useBreakpointValue as e, Flex as l, HStack as y } from "@chakra-ui/react";
import { m as f } from "framer-motion";
import { Typography as x } from "../Typography/Typography.mjs";
import { Button as c } from "../../forms/Button/Button.mjs";
import "../../forms/Button/IconButton.mjs";
import "../../forms/Button/ButtonGroup.mjs";
const v = ({
  onClick: n,
  rowSelection: i,
  selectedActions: t,
  selectedLabel: a
}) => {
  const p = m("Table"), s = e({ base: !0, md: !1 }, { fallback: "md" });
  return /* @__PURE__ */ r(
    l,
    {
      sx: p.rowSelectionContainer,
      as: f.div,
      initial: { y: "-24px", opacity: 0 },
      animate: {
        y: s ? 0 : -8,
        opacity: 1,
        transition: {
          type: "spring",
          stiffness: 700,
          damping: 30
        }
      },
      exit: { y: "-16px", opacity: 0 },
      children: [
        /* @__PURE__ */ r(y, { spacing: 2, children: [
          a && i && /* @__PURE__ */ o(x, { as: "span", variant: "bodyBoldSmall", children: a(Object.keys(i)) }),
          /* @__PURE__ */ o(c, { variant: "ghost", size: "sm", onClick: n, children: "Clear selection" })
        ] }),
        t == null ? void 0 : t(Object.keys(i))
      ]
    }
  );
};
export {
  v as RowSelection
};
